import React from 'react';
import DefaultLayout from '../../../layouts/default';
import { RotaProvider } from './context/RotaContext';
import RotaHeader from './components/RotaHeader';
import Step1Details from './components/Step1Details';
import Step2StaffSelection from './components/Step2StaffSelection';
import Step3Shifts from './components/Step3Shifts';
import Step4Checks from './components/Step4Checks';
import Step5Notifications from './components/Step5Notifications';
import Step6Settings from './components/Step6Settings';
import RotaFooter from './components/RotaFooter';

const AddWeeklyRotaPage = () => {
  return (
    <RotaProvider>
      <DefaultLayout>
        <div className="max-w-7xl mx-auto p-6 bg-slate-50 min-h-screen space-y-6">
          <RotaHeader />
          
          <main className="space-y-8">
            <Step1Details />
            <Step2StaffSelection />
            <Step3Shifts />
            <Step4Checks />
            <Step5Notifications />
            <Step6Settings />
          </main>

          <RotaFooter />
        </div>
      </DefaultLayout>
    </RotaProvider>
  );
};

export default AddWeeklyRotaPage;
